module.exports = __webpack_public_path__ + "img/2019jucan-2.b2a9092e.jpg";